module.exports = __webpack_public_path__ + "static/media/clouds_default.0a212205.jpg";